import { render, staticRenderFns } from "./AvailablePartsMain.vue?vue&type=template&id=bd71a3a8"
import script from "./AvailablePartsMain.vue?vue&type=script&lang=js"
export * from "./AvailablePartsMain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bd71a3a8')) {
      api.createRecord('bd71a3a8', component.options)
    } else {
      api.reload('bd71a3a8', component.options)
    }
    module.hot.accept("./AvailablePartsMain.vue?vue&type=template&id=bd71a3a8", function () {
      api.rerender('bd71a3a8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/quote/components/AvailablePartsMain.vue"
export default component.exports